import { createFileRoute } from '@tanstack/react-router'
import type { ChineseAnimal } from '@mysterra/engine'

import { ChineseHanzi } from '@/components/icons/chinese-hanzi'
import { KnowledgeListRow } from '@/features/knowledge/components/knowledge-list-row'
import { useCopy } from '@/lib/copy/use-copy'
import { useKnowledge } from '@/lib/copy/use-knowledge'

const CHINESE_ANIMALS: readonly ChineseAnimal[] = [
  'rat',
  'ox',
  'tiger',
  'rabbit',
  'dragon',
  'snake',
  'horse',
  'goat',
  'monkey',
  'rooster',
  'dog',
  'pig',
]

export const Route = createFileRoute('/wiedza/chinski')({
  component: WiedzaChinski,
})

function WiedzaChinski() {
  const { shell } = useCopy()
  const { data, isLoading, isError } = useKnowledge()
  const k = shell.knowledge

  return (
    <section className="space-y-4 p-5">
      <a
        href="/wiedza"
        className="font-mono text-hint tracking-[1.3px] text-element-ink-mute uppercase"
      >
        &larr; {k.categoryBackLabel}
      </a>
      <div>
        <h1 className="font-display text-[28px] leading-[1.05] text-element-ink italic">
          {k.sectionChinese}
        </h1>
        <p className="mt-1 text-hint text-element-ink-dim">
          {k.categoryChineseCount} wpisów · {k.categoryChineseHint}
        </p>
      </div>

      {isLoading && <p className="text-hint text-element-ink-dim">Ladowanie...</p>}
      {isError && (
        <p className="text-hint text-red-400">
          Nie udalo sie pobrac danych. Odswiez strone.
        </p>
      )}

      {data && (
        <div>
          {CHINESE_ANIMALS.map((animal) => {
            const copy = data.knowledge.chineseAnimal[animal]
            if (!copy) return null
            return (
              <KnowledgeListRow
                key={animal}
                iconSlot={<ChineseHanzi animal={animal} size={20} />}
                title={copy.label}
                body={copy.archetype}
                meta={k.typeTagChinese}
                href={`/wiedza/chinski/${animal}`}
              />
            )
          })}
        </div>
      )}
    </section>
  )
}
